import { render, staticRenderFns } from "./AxContent.vue?vue&type=template&id=47cca137"
import script from "./AxContent.vue?vue&type=script&lang=ts"
export * from "./AxContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports